require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.2@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 352
// module chunks = 0 1